import styled from 'styled-components';

import { DragDropArea } from 'components/primitives/drag-drop-area';
import { FILE_TYPE_DRIVER_LICENCE } from 'constants/deal';
import { PROCESS_STATUS } from './FileUpload.constants';

import { InfoSvg } from 'assets/img';

export const Container = styled.div`
  grid-area: ${(p) => p.gridArea || 'fup'};
  margin-top: 16px;
`;

export const DragDropStyled = styled(DragDropArea)`
  height: 85px;
  border-radius: 5px;
  border: ${(p) =>
    p.process !== PROCESS_STATUS.COMPLETED
      ? '2px dashed var(--color-yellow-1)'
      : '1px solid var(--color-green-1)'};
  background-color: ${(p) =>
    p.process !== PROCESS_STATUS.COMPLETED ? 'var(--color-yellow-1_17)' : 'var(--color-green-4)'};

  cursor: ${(p) => (p.isContentHidden ? 'not-allowed' : 'pointer')};

  svg {
    width: 30px;
  }
`;

export const InfoSvgStyled = styled(InfoSvg)`
  margin: 5px 0 0 0;
  width: 15px !important;
  height: 15px !important;
  fill: var(--color-grey-4);

  cursor: pointer;
`;

export const PageList = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

export const PageError = styled.div`
  font-size: 10px;
  color: ${(p) => (p.color && 'var(--color-red-2)') || 'var(--color-green-1)'};
  background-color: var(--color-blue-5);
  padding: ${(p) => (p.sysName === FILE_TYPE_DRIVER_LICENCE ? '4px 10px' : '4px 5px')};
  margin-right: 5px;
  margin-bottom: 5px;
  border-radius: 5px;

  &:last-child {
    margin-right: 0;
  }
`;

export const AreaInfo = styled.div`
  svg {
    cursor: pointer;
  }
`;
